import { AUTH_RESPONSE_PARAMS, isOrganizationReference, isProductKey, parseReturnPath, } from '@traceio-org/platform-contracts';
const REAUTHENTICATE_REASONS = [
    'sso_required',
    'mfa_required',
    'organization_login_required',
];
const MAX_CONTEXT_ID_LENGTH = 200;
function validPath(value) {
    const result = parseReturnPath(value);
    return result.ok ? result.path : undefined;
}
/**
 * Rebuilds app state from untrusted input, keeping only well-formed fields. App state lives in the
 * SDK's transaction storage on this origin, so tampering needs script access already; it is still
 * re-validated because a bad returnPath or hubPath would become a redirect.
 */
export function sanitizeAppState(input) {
    if (typeof input !== 'object' || input === null)
        return {};
    const raw = input;
    const state = {};
    if (isProductKey(raw.productKey))
        state.productKey = raw.productKey;
    const returnPath = validPath(raw.returnPath);
    if (returnPath)
        state.returnPath = returnPath;
    if (typeof raw.contextId === 'string' && raw.contextId.length > 0 && raw.contextId.length <= MAX_CONTEXT_ID_LENGTH) {
        state.contextId = raw.contextId;
    }
    if (isOrganizationReference(raw.organization))
        state.organization = raw.organization;
    const hubPath = validPath(raw.hubPath);
    if (hubPath)
        state.hubPath = hubPath;
    if (REAUTHENTICATE_REASONS.includes(raw.reauthenticate)) {
        state.reauthenticate = raw.reauthenticate;
    }
    if (raw.silent === true)
        state.silent = true;
    return state;
}
/** The app state carried through the identity provider for a sign-in. */
export function appStateFor(options) {
    return sanitizeAppState({
        productKey: options.productKey,
        returnPath: options.returnPath,
        contextId: options.contextId,
        organization: options.organization,
        hubPath: options.hubPath,
        reauthenticate: options.reauthenticate,
        silent: options.prompt === 'none' ? true : undefined,
    });
}
/** True when a URL query carries an authorization response (code or error, with state). */
export function hasAuthCallbackParams(search) {
    const params = new URLSearchParams(search);
    return params.has('state') && (params.has('code') || params.has('error'));
}
/** Returns the path, query and fragment of a URL without OAuth response parameters. */
export function withoutAuthResponseParams(href) {
    const url = new URL(href);
    for (const name of AUTH_RESPONSE_PARAMS)
        url.searchParams.delete(name);
    const query = url.searchParams.toString();
    return `${url.pathname}${query ? `?${query}` : ''}${url.hash}`;
}
//# sourceMappingURL=app-state.js.map